import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { company } from "../mock";

const CTA = () => {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-slate-900 px-8 py-14 lg:px-16 lg:py-20">
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-yellow-400/10 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-yellow-400/10 blur-3xl" />
          <div className="absolute inset-0 bg-dot opacity-30" />

          <div className="relative grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-400/15 text-yellow-300 text-xs font-semibold mb-4 border border-yellow-400/20">
                Klaar voor strak spuitwerk?
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight text-balance">
                Vraag uw vrijblijvende offerte aan.
              </h2>
              <p className="mt-4 text-slate-300 text-lg max-w-lg">
                Binnen 24 uur ontvangt u een eerlijke prijsopgave op maat.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row lg:justify-end gap-3">
              <Button
                asChild
                size="lg"
                className="bg-yellow-400 hover:bg-yellow-500 text-slate-900 font-semibold h-12 px-6"
              >
                <a href="#contact" className="flex items-center gap-2">
                  Offerte aanvragen <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="h-12 px-6 border-white/20 bg-white/5 text-white hover:bg-white/10 hover:text-white font-semibold"
              >
                <a href={`tel:${company.phoneRaw}`} className="flex items-center gap-2">
                  <Phone className="w-4 h-4" /> {company.phone}
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
